import { render, staticRenderFns } from "./form-submit.vue?vue&type=template&id=6f5b7b50"
import script from "./form-submit.vue?vue&type=script&lang=js"
export * from "./form-submit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports